import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Guardian extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Guardian';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'guardian', 'phone', 'relationships', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'guardian',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/guardians/' + this.id;
    }
}
